import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_GIFT_COLLECTION_ITEMS = gql(`
  query fetchGiftCollectionItems(
    $handle: String!
    $first: Int!
    $after: ID
  ) {
    collection: productCatalogCollection(handle: $handle) {
      id
      items(first: $first, after: $after) {
        nodes {
          variantGroup {
            id
            title
            availability
            images(first: 1) {
              url
            }
            color {
              id
              displayValue
              hexCodes
              swatchImage {
                url
              }
            }
            product {
              handle
              options(collectionHandle: $handle, scope: IN_COLLECTION) {
                colorsTotalCount
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`)
